import { PLATFORM_LABELS } from './socialPostView';

// Every sentence the club's calendar says about natively published posts, pure so
// each is asserted without jsdom. An empty intersection is not an empty result: a
// platform that did not answer, or a history cut short, must be SAID, or the club
// reads a quieter calendar as "nothing was posted".

const label = (p: string): string => PLATFORM_LABELS[p as keyof typeof PLATFORM_LABELS] ?? p;

function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}

/** null when every platform answered. */
export function externalFailureSentence(failures: ReadonlyArray<{ platform: string }>): string | null {
  const names = [...new Set(failures.map((f) => label(f.platform)))];
  if (names.length === 0) return null;
  return `We could not check ${joinNames(names)} just now, so posts made directly there may be missing from this calendar. Try Refresh in a moment.`;
}

/** null when the whole history was read. */
export function externalCappedSentence(capped: boolean): string | null {
  return capped ? 'Only the most recent natively published posts could be loaded, so older ones may be missing.' : null;
}

/** The two vendor limits we cannot fix from here. Always shown beside the legend. */
export const EXTERNAL_LIMITS_NOTE =
  'A post can take a little while to appear after it goes live on the platform. A post you have deleted on the platform may still show here until it drops out of the list we receive.';

export const EXTERNAL_READ_ONLY_NOTE =
  'Posts published directly on Facebook, Instagram or Google are shown in purple. They did not come through Kyck, so they cannot be edited or changed here: open one on the platform.';
